import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildApiUrl } from '../../config/api.config';

const OAuthCallback = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Check if there's a token in the URL or response
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const ownerToken = urlParams.get('ownerToken');
        const fromMaster = urlParams.get('fromMaster');
        const restaurantId = urlParams.get('restaurantId');

        if (token) {
          localStorage.setItem('token', token);
          if (restaurantId) localStorage.setItem('currentRestaurantId', restaurantId);
          if (fromMaster === 'true') {
            localStorage.setItem('fromMaster', 'true');
            if (ownerToken) localStorage.setItem('ownerToken', ownerToken);
          } else {
            localStorage.removeItem('fromMaster');
            localStorage.removeItem('ownerToken');
          }
          // Fetch user details to check if contact is provided
          const response = await fetch(buildApiUrl("/users/getuser"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": token
            }
          });

            if (response.ok) {
            const user = await response.json();
            
            // Check for Owner role to redirect to port 3001
            if (user.role === 'owner') {
               window.location.href = buildApiUrl(`/dashboard?token=${token}`);
               return;
            }

            // Check for Admin role
            if (user.role === 'admin') {
              if (user.restaurantId) {
                const rid = typeof user.restaurantId === 'object' ? (user.restaurantId._id || user.restaurantId.id) : user.restaurantId;
                localStorage.setItem('currentRestaurantId', rid);
              }
              props.showAlert("Admin Login Successful", "success");
              navigate("/admin");
              return;
            }

            // Check for Staff role
            if (user.role === 'staff') {
              if (user.parentRestaurantId) {
                const rid = typeof user.parentRestaurantId === 'object' ? (user.parentRestaurantId._id || user.parentRestaurantId.id) : user.parentRestaurantId;
                localStorage.setItem('currentRestaurantId', rid);
              }
              if (user.staffRole === 'manager') {
                props.showAlert("Manager Login Successful", "success");
                navigate("/admin");
              } else {
                props.showAlert("Staff Login Successful", "success");
                navigate("/admin/kitchen");
              }
              return;
            }

            if (!user.contact || user.contact.trim() === '') {
              // Contact not provided, redirect to complete profile
              localStorage.removeItem('currentRestaurantId');
              props.showAlert("Please complete your profile", "info");
              navigate("/complete-profile");
            } else {
              // Normal user: clear restaurant so they pick one every login
              localStorage.removeItem('currentRestaurantId');
              props.showAlert("Logged In Successfully with Google", "success");
              navigate("/");
            }
          } else {
            props.showAlert("OAuth login failed", "danger");
            navigate("/login");
          }
        } else {
          // If no token in URL, check if user is authenticated via session
          const existingToken = localStorage.getItem('token');
          if (existingToken) {
            const response = await fetch(buildApiUrl("/users/getuser"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "auth-token": existingToken
              }
            });

            if (response.ok) {
              const user = await response.json();
              if (!user.contact || user.contact.trim() === '') {
                // Contact not provided, redirect to complete profile
                props.showAlert("Please complete your profile", "info");
                navigate("/complete-profile");
              } else {
                // Don't show success alert here to avoid double notification
                navigate("/");
              }
            } else {
              props.showAlert("OAuth login failed", "danger");
              navigate("/login");
            }
          } else {
            props.showAlert("OAuth login failed", "danger");
            navigate("/login");
          }
        }
      } catch (error) {
        console.error("OAuth callback error:", error);
        props.showAlert("OAuth login failed", "danger");
        navigate("/login");
      }
    };

    handleOAuthCallback();
  }, [navigate, props]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#1B1C1F',
      color: '#ffffff'
    }}>
      <div>
        <h2>Processing Google Login...</h2>
        <p>Please wait while we complete your authentication.</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
